import { Button, ButtonProps } from '@mui/material';
import { t } from 'i18next';
import { DRIVER_STATUS, USER_ROLE } from '@utils/constants/enums';
import { useAppSelector } from '@hooks';
import './Button.scss';

interface ButtonStatusProps extends ButtonProps {
  status: DriverStatus;
  row?: ITableData;
  isTable?: boolean;
  handleClick?: () => void;
  onClickStatus?: (id: string) => void;
}

const ButtonStatus: React.FC<ButtonStatusProps> = ({
  status,
  row,
  isTable = false,
  handleClick,
  onClickStatus,
  ...prop
}) => {
  const { user } = useAppSelector(state => state.auth);
  if (!status) return null;

  let classname: 'pending' | 'approval' | 'final_approval' | 'restricted' =
    'pending';
  let disableRipple = false;
  let clickable = true;

  switch (status) {
    case DRIVER_STATUS.PENDING:
      classname = 'pending';
      break;
    case DRIVER_STATUS.APPROVAL:
      classname = 'approval';
      disableRipple = true;
      clickable = true;
      break;
    case DRIVER_STATUS.FINAL_APPROVAL:
      classname = 'final_approval';
      clickable =
        user.role !== USER_ROLE.RECEPTIONIST && user.role !== USER_ROLE.MANAGER;
      break;
    case DRIVER_STATUS.RESTRICTED:
      classname = 'restricted';
      disableRipple = true;
      clickable = true;
      break;
  }

  return (
    <Button
      disableRipple={disableRipple}
      className={`ButtonStatus ${classname}`}
      onClick={
        clickable
          ? isTable && row
            ? e => {
                e.stopPropagation();
                onClickStatus?.(row.id);
              }
            : handleClick
          : undefined
      }
      sx={{
        pointerEvents: clickable ? 'auto' : 'none',
        borderRadius: 0,
        height: '50px',
      }}
      {...prop}
    >
      {t(`status.${status}`)}
    </Button>
  );
};

export default ButtonStatus;
